import gql from "graphql-tag";

const getUserByID = gql`
  query getUserByID($id: ID!) {
    UserByID: getUserByID(id: $id) {
      id
      roleID
      countryID
      cityID
      extra {
        agencyID
      }
    }
  }
`;

export { getUserByID };
